const scrollToElement = (el: Element, offsetTop = 0) => {
    const targetOffsetTop = getElementOffset(el).top;

    const documentScrollTop =
        window.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || 0;

    const distanceFromTarget = targetOffsetTop - documentScrollTop - offsetTop;

    window.scrollBy({
        top: distanceFromTarget,
        behavior: 'smooth',
    });
};

// Get an element's absolute position on the page.
function getElementOffset(el: Element) {
    const rect = el.getBoundingClientRect();

    return {
        left: rect.left + (window.scrollX || window.pageXOffset),
        top: rect.top + (window.scrollY || window.pageYOffset),
    };
}

export default scrollToElement;
